import React from 'react';

import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SaveCountry } from '../../shared/components';

export type CreateCountryPageProps = {};

const CreateCountryPage: React.FC<CreateCountryPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_pais);

  return <SaveCountry titlePage="Crear País" />;
};

export default CreateCountryPage;
